<style scoped>

</style>
<template>
    <div>
        <Table :columns="columns" :data="expense_groups" :loading="loading"></Table>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        props: {
            log: {
                type: Object
            }
        },
        data(){
            return {
                loading: false,
                expense_groups: [],
                columns: [
                    {
                        title: '编号',
                        key: 'uid',
                        align: 'center'
                    },
                    {
                        title: '名称',
                        key: 'name',
                        align: 'center'
                    },
                    {
                        title: '申请人',
                        key: 'apply_user',
                        align: 'center'
                    },
                    {
                        title: '付款对象',
                        render: (h, params) => {
                            let ret = params.row.payee_user || params.row.payee_company;
                            return h('div', ret);
                        }
                    },
                    {
                        title: '总金额',
                        key: 'total_price',
                        align: 'right',
                        render: (h, params)=>{
                            let row = params.row;
                            return h('div', {
                                'class': {
                                    'text-right': true
                                }
                            }, Util.formatPrice(row.total_price));
                        }
                    }
                ]
            }
        },
        computed: {
            //
        },
        created(){
            this.getData();
        },
        mounted(){
            //
        },
        methods: {
            getData(){
                this.loading = true;
                Util.ajax.get(Util.api.expense_group_export_detail, {
                    params: {
                        id: this.log.id
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    if(res.code === 1){
                        let data = res.data;
                        this.expense_groups = data.expense_groups;
                    }else{
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.loading = false;
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            }
        }
    }
</script>
